import { globalProps } from "neetocommons/initializers";
import { Button, Modal, Typography } from "neetoui";
import { Trans, useTranslation } from "react-i18next";

import { useCreateSubscriptionRequest } from "./useSubscriptionRequestApi";

const SubscriptionUpgradeRequestModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const pricingPageUrl = `https://neeto.com/${globalProps.appName?.toLowerCase()}/pricing`;

  const { mutate: sendRequest, isPending } = useCreateSubscriptionRequest({
    onSuccess: onClose,
  });

  return (
    <Modal
      {...{ isOpen, onClose }}
      closeOnEsc={!isPending}
      closeOnOutsideClick={!isPending}
    >
      <Modal.Header>
        <Typography style="h3" weight="semibold">
          {t("neetoMolecules.subscriptionRequest.title")}
        </Typography>
      </Modal.Header>
      <Modal.Body>
        <Typography style="body2">
          <Trans
            components={{ strong: <strong /> }}
            i18nKey="neetoMolecules.subscriptionRequest.description"
          />
        </Typography>
        <Typography className="mt-3" style="body2">
          <Trans
            i18nKey="neetoMolecules.subscriptionRequest.pricingInfo"
            components={{
              pricingLink: (
                <a
                  className="neeto-ui-text-primary-500"
                  href={pricingPageUrl}
                  rel="noopener noreferrer"
                  target="_blank"
                />
              ),
            }}
          />
        </Typography>
      </Modal.Body>
      <Modal.Footer className="flex gap-x-2">
        <Button
          disabled={isPending}
          label={t("neetoMolecules.subscriptionRequest.cancel")}
          style="secondary"
          onClick={onClose}
        />
        <Button
          disabled={isPending}
          label={t("neetoMolecules.subscriptionRequest.sendRequest")}
          loading={isPending}
          style="primary"
          onClick={sendRequest}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default SubscriptionUpgradeRequestModal;
